import Vue from 'vue';
import fixedTools from './components/fixed-tools.vue';
import cookie from './cookie/cookie';
import warterMark from './utils/water-mark-config';
export default Vue.extend({
    name: 'App',
    data: function () {
        return {
            usernameZh: '',
        };
    },
    components: {
        'el-fixed-tools': fixedTools,
    },
    computed: {
        userId: function () {
            return this.usernameZh;
        },
    },
    created: function () {
        this.getUserName();
    },
    methods: {
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
    },
    watch: {
        userId: function (userId) {
            warterMark(userId);
        },
    },
});
